module.exports = {"id":"dp4_2l1q1","text":"Protecting personal data and privacy","instructions":"Sharing personal data online should generally be done with caution.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":false,"options":[{"id":"dp4_2l1q1-a1","text":"True","score":1.8},{"id":"dp4_2l1q1-a2","text":"Not sure","score":0},{"id":"dp4_2l1q1-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l1q1.json
// module id = 1223
// module chunks = 41